import has from 'lodash/has.js';

import axios from '@/plugins/axios.js';
import AccessDeniedInterceptor from '@/router/interceptors/AccessDeniedInterceptor.js';
import UnauthenticatedInterceptor from '@/router/interceptors/UnauthenticatedInterceptor.js';

export default ($store, $router) => {
    return [
        new AccessDeniedInterceptor($store, $router).processor(),
        new UnauthenticatedInterceptor($store, $router).processor(),
        {
            response: response => response,
            error: error => {
                if (!axios.isCancel(error) && !has(error, 'response.status')) {
                    return Promise.reject(error);
                }

                return Promise.reject(error);
            },
        },
    ];
};
